import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack/Stack';
import TextField from '@mui/material/TextField/TextField';
import Button from '@mui/material/Button/Button';
import Typography from '@mui/material/Typography/Typography';
import { getJudgeLinkCode } from '../../services/hackathon.service';

/**
 * Organizers: a link that makes whoever opens it (signed in) a judge, so judges needn't have signed in before being
 * added by email. "New link" replaces it; the old one stops working.
 */
export const JudgeLinkBox = ({ hackathonId, slug }: { hackathonId: string, slug: string }) => {
    const [code, setCode] = useState<string | null>(null);
    const [copied, setCopied] = useState(false);
    const [renewed, setRenewed] = useState(false);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        getJudgeLinkCode(hackathonId).then(setCode, err => console.error(err));
    }, [hackathonId]);

    const link = code ? `${window.location.origin}/h/${slug}?judge=${encodeURIComponent(code)}` : '';

    return (
        <Stack spacing={1}>
            <Typography>Or share a <b>judge link</b>: anyone who opens it and signs in becomes a judge, no invite code needed.</Typography>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                <TextField size="small" label="Judge link" value={link} sx={{ minWidth: 280, flex: 1 }}
                    inputProps={{ readOnly: true }} onFocus={e => e.target.select()} />
                <Button variant="contained" disabled={!link} onClick={() => {
                    navigator.clipboard?.writeText(link).catch(() => { });
                    setCopied(true);
                    window.setTimeout(() => setCopied(false), 2000);
                }}>{copied ? 'Copied' : 'Copy judge link'}</Button>
                <Button disabled={!link || busy} onClick={() => {
                    setBusy(true);
                    getJudgeLinkCode(hackathonId, true).then(next => {
                        setCode(next);
                        setRenewed(true);
                    }, err => console.error(err)).finally(() => setBusy(false));
                }}>New link</Button>
            </Stack>
            {renewed && <Typography variant="body2" color="text.secondary" role="status">New link made: the old one no longer works. Judges already added stay judges.</Typography>}
        </Stack>
    );
}
